import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get(`get-data-qualification-award`)
}
